import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
export default function CommingSoon() {
    const { t } = useTranslation();
    return (
        <section className="h-screen overflow-hidden flex flex-col items-center justify-center">
            <div className="w-[50%] h-[80%]">
                <img className="w-full h-full" src={require("../../assets/images/comming-soon.svg").default} alt="" />
            </div>
            <Link to={'/'} className="bg-[#09778d] text-white px-[30px] py-[8px] rounded-[4px] font-bold">{t("Go Back")}</Link>
        </section>
    );
}